const subjectTypes = Object.freeze({
  'languages&Cultures': {
    type: '',
    id: 1
  },
  'arts&Sciences': {
    type: '',
    id: 2
  },
  playersTrust: {
    type: '',
    id: 4
  },
  independentBasic: {
    type: 'independent_basic',
    id: 5
  },
  independentLanguage: {
    type: 'independent_language',
    id: 6
  },
  independentPlayersTrust: {
    type: 'independent_players_trust',
    id: 7
  }
})

export default subjectTypes
